export const isBot = () => {
  return /bot|crawler|google|baidu|bing|msn|teoma|slurp|yandex/i.test(
    navigator.userAgent,
  )
}
